import { type GasPayload } from '@atlaskit/analytics-gas-types';
import {
	type KnowledgeDiscoveryJiraIntentDetectionModelType,
	type KnowledgeDiscoveryJiraSearchClassificationType,
} from '@atlassian/search-client';

export type IntentRouterSelectedAttributes = {
	buttonPosition?: 0 | 1;
	searchSessionId: string;
	selectedMode: string;
	queryClassification: KnowledgeDiscoveryJiraSearchClassificationType;
	queryHash: string;
	queryLength: number;
	networkResponded: boolean;
	modelId?: KnowledgeDiscoveryJiraIntentDetectionModelType;
};

export const onIntentRouterSelected = ({
	attributes,
}: {
	attributes: IntentRouterSelectedAttributes;
}): GasPayload => ({
	source: 'searchDialog',
	eventType: 'ui',
	action: 'selected',
	actionSubject: 'intentRouter',
	actionSubjectId: 'intentRouterSelected',
	attributes,
});
